import { Box } from '@mantine/core';
import clsx from 'clsx';
import { dotPositionStyles } from './DotPositionStyles';
import './IconWithDot.css';
import React from 'react';

interface IconWithDotProps {
  dotColor: string;
  dotPosition?:
    | 'top'
    | 'top-right'
    | 'right'
    | 'bottom-right'
    | 'bottom'
    | 'bottom-left'
    | 'left'
    | 'top-left'
    | {
        top?: number;
        right?: number;
        bottom?: number;
        left?: number;
      };
  dotSize?: number;
  icon: React.ReactNode;
  className?: string;
  width?: number;
  height?: number;
}

export function IconWithDot({
  dotColor,
  dotPosition = 'bottom-right',
  dotSize = 13,
  icon,
  className,
  width,
  height,
}: React.PropsWithChildren<IconWithDotProps>) {
  return (
    <Box w={width} h={height} className={clsx('icon-with-dot', className)}>
      <Box className="icon-with-dot-icon">{icon}</Box>
      <Box
        className="icon-with-dot-dot"
        bg={dotColor}
        style={{
          width: dotSize,
          height: dotSize,
          ...(typeof dotPosition === 'string' ? dotPositionStyles[dotPosition] : dotPosition),
        }}
      />
    </Box>
  );
}
